import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Collapse
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { getLatestYear } from '../shared/historyUtils.js';

class PrefectureData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      province: null,
      noteCollapsed: false
    };
  }

  componentDidMount() {
    if(this.props.prefecture) {
      this.getProvince();
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.prefecture !== this.props.prefecture) {
      this.getProvince();
    }
  }

  getProvince() {
    const { prefecture } = this.props;
    if(!prefecture) return;

    fetch(prefecture.relationships.province.links.related).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ province: respJson.data });
      });
  }

  handleExploreClick() {
    const { prefecture } = this.props;
    const { province } = this.state;

    window.history.replaceState({ province, prefecture }, '', window.location.href);
    window.location.href = '/data_exploration/prefecture/' + prefecture.id;
  }

  getLatestPoint(dataPointName) {
    const { prefectureStats } = this.props;

    if(prefectureStats && prefectureStats[dataPointName]) {
      const latestYear = getLatestYear(prefectureStats[dataPointName]);
      return {
        year: latestYear,
        value: prefectureStats[dataPointName][latestYear]
      };
    }

    return null;
  }

  render() {
    const { prefecture, loading } = this.props;
    const { province, noteCollapsed } = this.state;
    const hasDistricts = prefecture && prefecture.relationships.districts.data.length > 0;

    const overviewItems = [
      { label: 'Population', point: this.getLatestPoint('Total Population') },
      { label: 'GDP', point: this.getLatestPoint('GDP') },
      { label: 'Per Cap GDP', point: this.getLatestPoint('Per Cap GDP') },
      { label: 'Retail Sales', point: this.getLatestPoint('Per Cap Retail Sales') }
    ].filter((item) => item.point);

    if(province && prefecture) {
      return (
        <Card className="sl-data-panel sl-location-panel sl-location-panel-wide sl-explorer-read-panel">
          <CardHeader className="sl-location-panel-header">
            <div className="sl-location-header-copy">
              <div className="sl-location-header-kicker">Market Read</div>
              <div className="sl-location-header-title">{prefecture.attributes.name}</div>
              <div className="sl-location-header-subtitle">{province.attributes.name} Province · China</div>
            </div>
            <div className="sl-location-header-actions">
              {hasDistricts && <div className="sl-location-header-badge">District view available</div>}
              {hasDistricts && (
                <Button className="sl-location-cta" size="sm" onClick={this.handleExploreClick.bind(this)}>
                  Explore full profile
                </Button>
              )}
            </div>
          </CardHeader>
          <CardBody className={loading ? 'text-center' : 'p-0'}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} size="4x" spin className="m-4 text-primary" />
            ) : (
              <div className="sl-location-panel-body">
                <div className="sl-location-overview">
                  <div className="sl-location-overview-copy">
                    <div>
                      <div className="sl-location-overview-title">Why this market stands out</div>
                      <p className="sl-location-overview-text">Scan the lead indicators below, then jump into district-level detail when you are ready.</p>
                    </div>
                  </div>
                  <div className="sl-overview-grid">
                    {overviewItems.map((item) => (
                      <div className="sl-overview-card" key={item.label}>
                        <div className="sl-overview-label">{item.label}</div>
                        <div className="sl-overview-value">{item.point.value}</div>
                        <div className="sl-overview-year">{item.point.year}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {prefecture.relationships.note && prefecture.relationships.note.data && (
                  <div className={'panel-section sl-category-panel sl-category-panel-wide tone-note' + (noteCollapsed ? ' is-collapsed' : '')}>
                    <button type="button" className="sl-category-head sl-category-toggle" onClick={() => this.setState((s) => ({ noteCollapsed: !s.noteCollapsed }))}>
                      <div>
                        <div className="panel-section-label">Note</div>
                        <p className="sl-category-copy">Additional context captured for this prefecture.</p>
                      </div>
                      <div className="sl-category-head-meta">
                        <span className="sl-category-count">Analyst context</span>
                        <FontAwesomeIcon icon={noteCollapsed ? faChevronDown : faChevronUp} className="sl-category-chevron" />
                      </div>
                    </button>
                    <Collapse isOpen={!noteCollapsed}>
                      <div className="sl-category-collapse">
                        <div className="sl-category-body sl-note-block">
                          <div className="sl-note-title">{prefecture.relationships.note.data.title}</div>
                          <p className="sl-note-body">{prefecture.relationships.note.data.body}</p>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                )}
              </div>
            )}
          </CardBody>
        </Card>
      );
    }

    return null;
  }
}

export default PrefectureData;
